// extracted by mini-css-extract-plugin
module.exports = {"buttonIcon":"sdsButtons_buttonIcon__RnOR2"};